import { supabase } from "../../supabase";
import { toBase64 } from "../../functions/base64";
import { Link, useNavigate } from "react-router-dom";
import ProjectHeader from "../../components/common/ProjectHeader/ProjectHeader";
import Flower from "../../components/common/Flower/Flower";
import ClickFlower from "../../components/common/ClickFlower/ClickFlower";
import { IoIosArrowBack } from "react-icons/io";


export default function OnlineCreateProject() {
  const navigate = useNavigate();
  // Tworzenie nowego projektu
  const createProject = async (e) => {
    e.preventDefault();

    const user = supabase.auth.getUser();

    const title = e.target.title.value;
    const description = e.target.description.value;
    const words = parseInt(e.target.words.value, 10);
    const finishDate = e.target.finishDate.value;
    let cover = e.target.cover.files[0];
    
    if (cover) {
      cover = await toBase64(cover)
    }

    // Wstawienie projektu do bazy
    const { data, error } = await supabase
      .from('projects')
      .insert({
        user_id: user.id,
        title,
        description,
        words,
        actualwords: 0,
        finishDate,
        cover,
        history: [],
        settings: {
          chaptersEnabled: false,
          MinimumWordsInChapter: 1000,
          goalEnabled: false,
          goalMode: "Auto",
          dailyGoal: 0,
          lastGoalUpdate: ""
      },
      chapters: []
      })
      .select()
      .single();

    if (error) alert(error.message);
    navigate(`/online/project/${data.id}`);
  };

    return(
        <div className="projectlist-wrapper">
              <ProjectHeader
                  headerTitle={"Stwórz projekt"}
                  showBackButton={true}
                  path={`/online`}
              /> 
               <div className="SettingsForm" style={{marginTop: '100px'}}>
                <form onSubmit={createProject}>
                        <label>
                          Tytuł projektu
                          <input type="text" name="title" required className="chapterInput" />
                        </label>
        
                        <label>
                          Opis
                          <textarea name="description" className="chapterInput" />
                        </label>
        
                        <label>
                          Liczba słów
                          <input type="number" name="words" required className="chapterInput"/>
                        </label>
        
                        <label>
                          Kiedy chcesz skończyć
                          <input type="date" className="chapterInput" name="finishDate"/>
                        </label>
        
                        <label>
                          Okładka
                          <input type="file" accept="image/*" name="cover" className="chapterInput" />
                        </label>
        
                        <button className="primary-btn">Utwórz projekt</button>
                </form>
        
               </div>
        
               <Link to={`/online`} className="BackfixButton"><IoIosArrowBack /></Link>
                <Flower
                  flowerClass={"flower1"}/>
                <Flower
                  flowerClass={"flower2"}/>
                <ClickFlower/>
            </div>

    )
}